export default "__VITE_ASSET__ClUEWw7C__"